export default __webpack_public_path__ + "static/media/1606.fdec66d6.png";